<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="(type === 'add' ? '新增' : '修改') + 'GPS费'"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    :append-to-body="true"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form
        @sub="sub"
        :noSubBtn="true"
        ref="customForm"
        :formData="formData"
        labelWidth="130px"
      >
        <section slot="car" slot-scope="prop">
          <ChooseCar
            :isRadio="true"
            v-model="prop.form.car"
            @change="handleCarChange"
            :otherSearchData="{
              orgId,
            }"
          />
        </section>
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="customFormPost"
        :loading="subLoading || getDetailLoading"
      >确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import ChooseCar from 'components/choose/car';
export default {
  components: {
    ChooseCar,
  },
  props: {
    orgId: {
      type: Number,
    },
  },
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '车牌号码',
            value: 'car',
            slot: true,
            default: {},
          },
          {
            label: '牌照类型',
            value: 'licenceTypeName',
            type: 'input',
            placeholder: '请输入牌照类型',
            disabled: true,
          },
          {
            label: '套装类型',
            value: 'suitType',
            type: 'select',
            placeholder: '请选择套装类型',
            options: [
              {
                label: '定位设备',
                value: '1',
              },
              {
                label: '油耗设备',
                value: '2',
              },
              {
                label: '定位+油耗设备',
                value: '3',
              },
            ],
          },
          {
            label: '服务失效日期',
            value: 'serviveLoseDate',
            placeholder: '请选择服务失效日期',
            type: 'date',
            width: '240px',
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '设备号',
            value: 'equipmentNumber',
            type: 'input',
            placeholder: '请输入设备号',
          },

          {
            label: '费用日期',
            value: 'feeAscriptionDate',
            type: 'date',
            default: '',
            attr: {
              time: '00:00:00',
            },
          },

          // {
          //   label: '油耗设备品牌',
          //   value: 'oilWearEquoipmentBrand',
          //   type: 'input',
          //   placeholder: '请输入油耗设备品牌',
          // },
          // {
          //   label: '定位设备品牌',
          //   value: 'gpsEquoipmentBrand',
          //   type: 'input',
          //   placeholder: '请输入定位设备品牌',
          // },
          // {
          //   label: '油耗设备型号',
          //   value: 'oilWearEquoipmentModel',
          //   type: 'input',
          //   placeholder: '请输入油耗设备型号',
          // },
          // {
          //   label: '定位设备型号',
          //   value: 'gpsEquoipmentModel',
          //   type: 'input',
          //   placeholder: '请输入定位设备型号',
          // },
          // {
          //   label: '油耗设备号',
          //   value: 'oilWearEquoipmentNumber',
          //   type: 'input',
          //   placeholder: '请输入油耗设备号',
          // },
          // {
          //   label: '定位设备号',
          //   value: 'gpsEquoipmentNumber',
          //   type: 'input',
          //   placeholder: '请输入定位设备号',
          // },

          {
            label: '套装费用',
            value: 'suitFee',
            type: 'input',
            placeholder: '请输入套装费用',
            unit: '元',
          },
          // {
          //   label: '申请金额',
          //   value: 'payAmt',
          //   type: 'input',
          //   placeholder: '请输入申请金额',
          // },
          {
            label: '上传附件',
            value: 'detailPic',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            default: [],
          },
        ],
        rules: { // 表单验证规则
          car: [ // 车牌号码
            { required: true, message: '请选择车牌号码', trigger: 'blur' },
          ],
          suitType: [ // 套装类型
            { required: true, message: '请选择套装类型', trigger: 'blur' },
          ],
          serviveLoseDate: [ // 服务失效日期
            { required: true, message: '请选择服务失效日期', trigger: 'blur' },
          ],
          suitFee: [ // 套装费用
            { required: true, message: '请输入套装费用', trigger: 'blur' },
          ],
          feeAscriptionDate: [
            { required: true, message: '请输入费用日期', trigger: 'blur' },
          ],
          // payAmt: [ // 申请金额
          //   { required: true, message: '请输入申请金额', trigger: 'blur' },
          // ],
        },
      },
    };
  },
  methods: {
    handleCarChange (item) {
      const car = this.$refs.customForm.getVal('car');
      this.$refs.customForm.setVal('licenceTypeName', car.licenceTypeName);
    },

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$nextTick(() => {
        this.$refs.customForm && this.$refs.customForm.reset();
        this.originData = item;
        if (item) { // 修改
          this.type = 'edit';
          item.car = {
            plateNumber: item.plateNumber,
            licenceType: item.licenceType,
            licenceTypeName: item.licenceTypeName,
          };
          this.$refs.customForm.setVal(item);
          this.handleCarChange();
        } else { // 新增
          this.type = 'add';
        }
      });
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      // 车牌号码
      form.plateNumber = form.car.plateNumber;
      form.licenceType = form.car.licenceType;
      form.licenceTypeName = form.car.licenceTypeName;
      form.feeAscriptionDate = this.formatDate(form.feeAscriptionDate);
      delete form.car;
      // 套装类型
      switch (String(form.suitType)) {
        case '1':
          form.suitTypeName = '定位设备';
          break;
        case '2':
          form.suitTypeName = '油耗设备';
          break;
        case '3':
          form.suitTypeName = '定位+油耗设备';
          break;
        default:
          form.suitTypeName = '--';
          break;
      }
      // 服务失效日期
      form.serviveLoseDate = this.formatDate(form.serviveLoseDate, 1);
      form.payAmt = form.suitFee;
      this.$emit('sub', {
        form,
        originData: this.originData,
      });
      this.dialogFormVisible = false;
    },
  },
};
</script>

<style>
</style>
